import { IElementType } from "core-integration/src/store/element-types/types";
import { IElement } from "core-integration/src/store/elements/types";
import { ITeam } from "core-integration/src/store/teams/types";
import { ellipsis } from "polished";
import * as React from "react";
import styled from "styled-components";
import ElementShirt from "./ElementShirt";
import Media from "./Media";

const MenuButton = styled.button`
  ${ellipsis()};
  width: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  color: inherit;
  font-family: ${({ theme }) => theme.fonts.base};
  text-align: start;
  cursor: pointer;
`;

const Name = styled.div`
  ${ellipsis()};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    text-decoration: underline;
  }
`;

const Info = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
`;

const Team = styled.div`
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: medium;
`;

const Position = styled.div`
  font-size: ${({ theme }) => theme.fontSizes[1]};
`;

interface IOwnProps {
  element: IElement;
  elementType: IElementType;
  renderElementMenu: () => void;
  team: ITeam;
}

type Props = IOwnProps;

const ElementInTable: React.FC<Props> = ({
  element,
  elementType,
  renderElementMenu,
  team,
}) => {
  const Shirt = <ElementShirt elementId={element.id} sizes="24px" />;
  return (
    <MenuButton onClick={renderElementMenu}>
      <Media img={Shirt} centred={true}>
        <Name>{element.web_name}</Name>
        <Info>
          <Team>{team.short_name}</Team>
          <Position>{elementType.singular_name_short}</Position>
        </Info>
      </Media>
    </MenuButton>
  );
};

export default ElementInTable;
